import "twin.macro";

import { useState } from "react";
import { useSelector } from "react-redux";

import { Publish } from "@mui/icons-material";
import { Button } from "@mui/material";

import {
  FixedHeightScrollLastChild,
  PageTitle,
} from "@components/StyledComponents";
import AddressBookTutorial from "@components/tutorial/AddressBookTutorial";
import { Filters, useFilterParams } from "@features/filters";

import AddressBookTable from "./AddressBookTable";
import AddressModal from "./AddressModal";
import { usePaginatedAddressBookQuery } from "./addressQueries";
import BulkUploadAddressesModal from "./bulkUpload/BulkUploadAddressesModal";

const AddressPage = () => {
  const [modal, setModal] = useState(false);
  const [modalType, setModalType] = useState<any>("edit");
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [currentAddressId, setCurrentAddressId] = useState<string | null>(null);

  const { role, hasViewedAddressBook } = useSelector(
    (state: any) => state.currentUser
  );
  const [filterParams] = useFilterParams();

  const { data, ...tableProps } = usePaginatedAddressBookQuery({
    filter: {
      searchTerm: filterParams.q,
      stateIds: filterParams.states,
    },
    sort: filterParams.sort,
  });

  const addresses = data ?? [];

  const handleModalClose = () => {
    setModal(false);
    setCurrentAddressId(null);
  };

  const handleModalOpen = (id, type) => {
    setCurrentAddressId(id);
    setModalType(type);
    setModal(true);
  };

  return (
    <FixedHeightScrollLastChild>
      {!tableProps.isLoading &&
        !hasViewedAddressBook &&
        role !== "read-only" && <AddressBookTutorial />}
      {modal && (
        <AddressModal
          open={modal}
          handleClose={handleModalClose}
          type={modalType}
          id={currentAddressId}
        />
      )}
      {bulkUploadModal && (
        <BulkUploadAddressesModal onClose={() => setBulkUploadModal(false)} />
      )}
      <div tw="flex flex-col gap-2 xl:(flex-row justify-between items-center)">
        <PageTitle>Edit Addresses</PageTitle>
        <div tw="flex gap-2 items-center">
          <Button
            variant="contained"
            color="primary"
            className="tutorial-highlight"
            id="tutorial-new-address"
            onClick={() => handleModalOpen(null, "new")}
          >
            NEW ADDRESS
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<Publish />}
            onClick={() => setBulkUploadModal(true)}
            id="tutorial-bulk-upload"
          >
            UPLOAD BULK ADDRESSES
          </Button>
        </div>
      </div>
      <Filters
        searchTitle="Search Addresses"
        slots={["states"]}
        defaultValues={{ sort: "name" }}
      />
      <AddressBookTable
        rows={addresses}
        query={filterParams.q}
        onRowClick={(row) => handleModalOpen(row.id, "edit")}
        {...tableProps}
      />
    </FixedHeightScrollLastChild>
  );
};

export default AddressPage;
